<form #filterForm="ngForm">
    <div class="row">
        <div class="col-6 form-field">
            <input class="form-control"
                   [placeholder]="'hospitalDashboard_doctors_search' | translate"
                   [(ngModel)]="filters.search"
                   name="filterSearch"
                   (input)="filter()">
        </div>
    </div>
</form>

<app-table [rows]="rows" [columns]="columns">
    <ng-template #rowTemplate let-row>
        <tr>
            <td>{{row.Name}} {{row.Surname}}</td>
            <td>{{row.Email}}</td>
            <td>{{row.Hospital}}</td>
            <td>
                <button type="button" class="btn btn-icon btn-outline" (click)="openSeminars(row)"
                        [ngbTooltip]="'hospitalDashboard_doctors_openSeminars' | translate">
                    <i class="fi fi-rs-list"></i>
                </button>
            </td>
        </tr>
    </ng-template>
</app-table>
